import { RightOutlined } from "@ant-design/icons";
import { Card, Col, Row, Typography } from "antd";
import React from "react";

const Highlights = ({ product }) => {
  return (
    <>
      <Typography.Title
        level={3}
        className="highlights-title"
        style={{ marginBottom: "16px", textAlign: "center" }}
      >
        Product Highlights
      </Typography.Title>
      <Row gutter={[24, 24]}>
        {product?.product_highlite &&
          product?.product_highlite.map((highlight, index) => (
            <Col key={index} xs={24} sm={24} md={12} lg={12} xl={12}>
              <Card
                style={{
                  marginBottom: "16px",
                  boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.05)",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      marginRight: "12px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <RightOutlined
                      style={{
                        color: "#1890ff",
                        fontSize: "14px",
                      }}
                    />
                    <RightOutlined
                      style={{
                        color: "#87CEEB",
                        fontSize: "14px",
                        marginLeft: "-9px",
                      }}
                    />
                  </div>
                  <div>
                    <Typography.Text strong className="highlight-heading">
                      {highlight.heading}
                    </Typography.Text>
                    <Typography.Paragraph
                      className="highlight-text"
                      style={{ marginBottom: 0 }}
                    >
                      {highlight.highlite}
                    </Typography.Paragraph>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
      </Row>
    </>
  );
};

export default Highlights;
